'use client';

import { useMemo, type FC, Fragment } from 'react';
import { Button, Text, Flex, Tooltip } from '@/_components';
import styles from './ParticipantList.module.css';
import type { ParticipantListProps } from './ParticipantList.types';

export const ParticipantList: FC<ParticipantListProps> = ({ conversation }) => {
  const formattedParticipants: string = useMemo(() => {
    const MAX_VISIBLE: number = 2;
    const names: string[] = conversation?.client_names || [];

    return names.length <= MAX_VISIBLE
      ? names.join(', ')
      : `${names.slice(0, MAX_VISIBLE).join(', ')} and ${names.length - MAX_VISIBLE} more`;
  }, [conversation?.client_names]);

  if (!conversation?.client_names?.length) return null;

  return (
    <Flex className={styles.participantListContainer} isYCentered={true}>
      <Flex
        gap={4}
        isYCentered={true}
        className={styles.participantList}
        isBetween={true}
      >
        <Text
          fontWeight="medium"
          type="tiny"
          color="currentcolor"
          className={styles.participantList__text}
        >
          You are sending a message to <span>{formattedParticipants}</span>
        </Text>
        <Tooltip placement="bottom">
          <Tooltip.Trigger>
            <Button
              value="Info"
              intent="ghost"
              iconLeft="info"
              size="tiny"
              isIconOnly={true}
            />
          </Tooltip.Trigger>
          <Tooltip.Content>
            <Flex isColumn={true} gap={4}>
              <Text type="tiny" color="currentcolor" isEllipsis={true}>
                Participants:
              </Text>
              <Text type="tiny" color="currentcolor" isEllipsis={true}>
                {conversation?.client_names?.map((c, key) => (
                  <Fragment key={key}>
                    &middot; {c}
                    <br />
                  </Fragment>
                ))}
              </Text>
            </Flex>
          </Tooltip.Content>
        </Tooltip>
      </Flex>
    </Flex>
  );
};
